import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, Calendar, CheckCircle, Clock, Users } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberBandi() {
  const { user } = useAuth();
  const [bandi, setBandi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { axios.get(`${API}/bandi`).then(r => setBandi(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  const partecipa = async (id) => {
    try {
      await axios.post(`${API}/bandi/${id}/partecipa`, {});
      toast.success("Partecipazione registrata!");
      setBandi(prev => prev.map(b => b.id === id ? { ...b, partecipanti: [...(b.partecipanti || []), user.id] } : b));
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
  };

  if (loading) return <div className="text-center py-12 text-white/30">Caricamento bandi...</div>;

  return (
    <div data-testid="member-bandi" className="space-y-3">
      <p className="text-sm text-white/40 mb-4">{bandi.length} bandi disponibili</p>
      {bandi.map(b => {
        const joined = b.partecipanti?.includes(user?.id);
        return (
          <div key={b.id} className="glass-card rounded-lg border border-white/8 p-5 hover:border-[#00A0D1]/20 transition-all" data-testid={`member-bando-${b.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <FileText className="w-5 h-5 text-[#00A0D1] flex-shrink-0" />
                  <h3 className="text-base font-semibold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>{b.titolo}</h3>
                  <Badge className={`text-[10px] border ${b.stato === "aperto" ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-red-500/10 text-red-400 border-red-500/20'}`}>{b.stato}</Badge>
                </div>
                <p className="text-sm text-white/40 ml-8 mb-3">{b.descrizione}</p>
                <div className="flex flex-wrap items-center gap-4 ml-8">
                  {b.scadenza && <div className="flex items-center gap-1.5 text-xs text-white/25"><Calendar className="w-3.5 h-3.5" /> {b.scadenza}</div>}
                  <div className="flex items-center gap-1.5 text-xs text-white/25"><Users className="w-3.5 h-3.5" /> {b.partecipanti?.length || 0}</div>
                  {b.tipo && <Badge className="bg-white/5 text-white/40 border-white/10 text-[10px] border">{b.tipo}</Badge>}
                </div>
              </div>
              <div className="flex-shrink-0">
                {joined ? (
                  <div className="flex items-center gap-1.5 text-emerald-400 text-sm font-medium" data-testid={`bando-partecipato-${b.id}`}><CheckCircle className="w-4 h-4" /> Iscritto</div>
                ) : b.stato === "aperto" ? (
                  <Button data-testid={`bando-participate-button-${b.id}`} onClick={() => partecipa(b.id)} className="bg-[#00A0D1] text-white hover:bg-[#00A0D1]/90 text-sm">Partecipa</Button>
                ) : (
                  <div className="flex items-center gap-1.5 text-white/25 text-sm"><Clock className="w-4 h-4" /> Chiuso</div>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {bandi.length === 0 && <div className="text-center py-12 text-white/30">Nessun bando disponibile</div>}
    </div>
  );
}
